import React from 'react';
import { Box } from '@mui/material';

import { Amount } from '../../../../../finance/shared/amount-view/Amount/Amount';

export const ExpenseVariableAmountSection = ({ sx, amount, maximumEventAmount, totalAmount, variance, createMode }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        '.eds-amount': {
          fontWeight: 600
        },
        ...sx
      }}
    >
      <Box
        data-testid="amount"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          maxWidth: '33%'
        }}
      >
        <span>Amount</span>
        <Amount coinsAmount={amount} showDollarSign={true} />
      </Box>
      <Box
        data-testid="max-amount"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1
        }}
      >
        <span>Maximum</span>
        <Amount coinsAmount={maximumEventAmount} showDollarSign={true} defaultZeroValue={'N/A'} />
      </Box>
      {maximumEventAmount === 0 ? (
        <Box
          data-testid="total-amount"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1
          }}
        >
          <span>Total Amount</span>
          <Amount coinsAmount={totalAmount} showDollarSign={true} />
        </Box>
      ) : (
        createMode && (
          <Box
            data-testid="variance"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1
            }}
          >
            <span>Remaining</span>
            <Amount coinsAmount={variance} showDollarSign />
          </Box>
        )
      )}
    </Box>
  );
};
